import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import { configure } from 'vue-gtag'
import './index.css'
import App from './App.vue'
import router from './router'
import { Toaster } from 'vue-sonner'
import 'vue-sonner/style.css'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)

// Configure Google Analytics
if (import.meta.env.VITE_GA_MEASUREMENT_ID) {
    configure({
        tagId: import.meta.env.VITE_GA_MEASUREMENT_ID,
        config: {
            send_page_view: false
        }
    })
}

app.component('Toaster', Toaster)
app.mount('#app')
